import { useState, useEffect, useRef, useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';

const CaretToggle = ({ children, title, initiallyOpen = false }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 990px)' });
    const [toggleFilterCaret, setToggleFilterCaret] = useState(initiallyOpen);
    const initialRender = useRef(true);
    
    // Function to create valid ID strings
    const createValidId = (str) => {
        return str
            .toLowerCase()
            .replace(/\s+/g, '-')     // Replace spaces with hyphens
            .replace(/[^a-z0-9-]/g, '') // Remove any characters that aren't letters, numbers, or hyphens
            .replace(/--+/g, '-')      // Replace multiple hyphens with single hyphen
            .replace(/^-+|-+$/g, '');  // Remove leading/trailing hyphens
    };

    // Create IDs once for consistent reference
    const headingId = `filter-heading-${createValidId(title)}`;
    const contentId = `filter-content-${createValidId(title)}`;
    
    useEffect(() => {
        if (initialRender.current) {
            if (!isMobile && (title === 'Brand' || title === 'Category' || initiallyOpen)) {
                setToggleFilterCaret(true);
            } else {
                setToggleFilterCaret(false);
            }
            initialRender.current = false;
        }
    }, [isMobile, title, initiallyOpen]);

    const handleToggle = useCallback(() => {
        setToggleFilterCaret(prev => !prev);
    }, []);

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleToggle();
        }
    };

    return (
        <div 
            className={`filter-sidebar-module ${!toggleFilterCaret ? 'filter-inactive' : ''}`}
            role="region"
            aria-labelledby={headingId}
        >
            <div 
                className="filter-sidebar-header"
                role="button"
                onClick={handleToggle}
                onKeyPress={handleKeyPress}
                tabIndex="0"
                aria-expanded={toggleFilterCaret}
                aria-controls={contentId}
            >
                <div id={headingId} className="filter-sidebar-title">
                    {title}
                </div>
                <div 
                    className="filter-sidebar-caret"
                    aria-hidden="true"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <path d="M212.7 331.3c6.2 6.2 16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4 75.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l160 160z" />
                    </svg>
                </div>
            </div>
            <div 
                id={contentId}
                className={toggleFilterCaret ? 'filter-content-visible' : 'filter-content-hidden'}
            >
                {toggleFilterCaret && children}
            </div>
        </div>
    );
};

export default CaretToggle;
